/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NovitusInvoiceDto } from './NovitusInvoiceDto';
import {
    NovitusInvoiceDtoFromJSON,
    NovitusInvoiceDtoFromJSONTyped,
    NovitusInvoiceDtoToJSON,
} from './NovitusInvoiceDto';

/**
 * 
 * @export
 * @interface NovitusInvoicePayloadDto
 */
export interface NovitusInvoicePayloadDto {
    /**
     * Dane faktury ze wszystkimi wymaganymi polami
     * @type {NovitusInvoiceDto}
     * @memberof NovitusInvoicePayloadDto
     */
    invoice: NovitusInvoiceDto;
}

/**
 * Check if a given object implements the NovitusInvoicePayloadDto interface.
 */
export function instanceOfNovitusInvoicePayloadDto(value: object): value is NovitusInvoicePayloadDto {
    if (!('invoice' in value) || value['invoice'] === undefined) return false;
    return true;
}

export function NovitusInvoicePayloadDtoFromJSON(json: any): NovitusInvoicePayloadDto {
    return NovitusInvoicePayloadDtoFromJSONTyped(json, false);
}

export function NovitusInvoicePayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusInvoicePayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice': NovitusInvoiceDtoFromJSON(json['invoice']),
    };
}

export function NovitusInvoicePayloadDtoToJSON(value?: NovitusInvoicePayloadDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'invoice': NovitusInvoiceDtoToJSON(value['invoice']),
    };
}

